module.exports = __webpack_public_path__ + "static/activebarre-studio2-faaae776ac1101f2af4207066b364630.jpg";